module.exports = __webpack_public_path__ + "static/media/KA.31b7f87c.png";